import React from 'react'

function Navigation() {
    return (
        <div className="navigation-group">

            <div className="top-bar">

                <div className="container top-bar-content">

                    <div className="horizontal-flex">

                        <div>Server Status:&nbsp;<span className="online">Online</span></div>

                    </div>

                    <div className="horizontal-flex"><a href="https://elyxrsps.com/forums/login" className="login">Login</a><a href="https://elyxrsps.com/forums/register" className="register">Register on Forums</a></div>

                </div>

            </div>

            <div data-collapse="medium" data-animation="default" data-duration="400" className="navigation-bar w-nav">

                <div className="container navigation-container">

                    <nav role="navigation" className="nav-menu w-nav-menu"><a href="https://elyxrsps.com/" className="navigation-link w-nav-link">Home</a><a href="https://elyxrsps.com/forums/" className="navigation-link w-nav-link">forums</a><a href="https://discord.gg/E9cTgxKuSG" rel="noreferrer" target="_blank" className="navigation-link w-nav-link">Discord</a><a href="https://elyxrsps.com/" className="logo desktop w-inline-block"></a><a href="https://elyxrsps.com/vote/" className="navigation-link w-nav-link">vote</a><a href="https://elyxrsps.com/store/" className="navigation-link w-nav-link">store</a><a href="https://elyxrsps.com/hiscores/" className="navigation-link w-nav-link">hiscores</a></nav>

                    <div className="menu-button w-nav-button">

                        <div className="icon w-icon-nav-menu"></div>

                    </div>

                </div>

                <div className="w-nav-overlay" data-wf-ignore=""></div></div>

        </div>
    )
}

export default Navigation